import React from 'react';
import { Box } from '@mui/material';
import {
    FaDatabase,
    FaClipboardList,
    FaUsers,
    FaUser,
} from 'react-icons/fa';
import {
    Navigate,
    Route,
    Routes,
    useLocation,
    useNavigate
} from 'react-router-dom';
import Header from '../../Common/Header/Header';
import ChartsContainer from '../Common/ChartsContainer';
import DatabaseWrapper from './Database';
import CollectionMethodWrapper from './CollectionMethod';
import FamiliesWrapper from './Families';
import PeopleWrapper from './People';

const menus = [
    {
        title: 'Banco de Dados',
        path: '/governanceroom/dashboardunifiedregistry/mapping/database',
        icon: <FaDatabase style={{ marginRight: '5px' }} />
    },
    {
        title: 'Forma de Coleta',
        path: '/governanceroom/dashboardunifiedregistry/mapping/collection-method',
        icon: <FaClipboardList style={{ marginRight: '5px' }} />
    },
    {
        title: 'Famílias',
        path: '/governanceroom/dashboardunifiedregistry/mapping/families',
        icon: <FaUsers style={{ marginRight: '5px' }} />
    },
    {
        title: 'Pessoas',
        path: '/governanceroom/dashboardunifiedregistry/mapping/people',
        icon: <FaUser style={{ marginRight: '5px' }} />
    }
];

const titleMap = {
    '/governanceroom/dashboardunifiedregistry/mapping/database':
        'Dados Gerais do Banco de Dados do Cadastro Único',
    '/governanceroom/dashboardunifiedregistry/mapping/collection-method':
        'Forma de Coleta de Dados',
    '/governanceroom/dashboardunifiedregistry/mapping/families':
        'Mapeamento Social das Famílias',
    '/governanceroom/dashboardunifiedregistry/mapping/people':
        'Mapeamento Social das Pessoas'
};

const Mapping = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleHomeClick = () => {
        navigate('/governanceroom/dashboardunifiedregistry');
    };

    return (
        <Box>
            <Header menus={menus} onHomeClick={handleHomeClick} />
            <Box className="content">
                <ChartsContainer
                    title={titleMap[location.pathname]}
                    className="services-container-dashboards"
                >
                    <Routes>
                        <Route path="database" element={<DatabaseWrapper />} />

                        <Route
                            path="collection-method"
                            element={<CollectionMethodWrapper />}
                        />

                        <Route path="families" element={<FamiliesWrapper />} />

                        <Route path="people" element={<PeopleWrapper />} />

                        <Route
                            path="/"
                            element={<Navigate to="database" replace />}
                        />
                    </Routes>
                </ChartsContainer>
            </Box>
        </Box>
    );
};

export default Mapping;
